<template>
  <div class="payment-plans-list">
    <div
      class="d-flex flex-column justify-content-start align-items-center flex-nowrap"
    >
      <ProductPaymentPlan
        class="w-100 mb-4"
        v-for="paymentPlan in paymentPlans"
        :key="paymentPlan.id"
        :paymentPlan="paymentPlan"
        @edit="$emit('edit', paymentPlan)"
        @remove="$emit('remove', paymentPlan)"
      />
      <div
        class="d-flex flex-row justify-content-start align-items-center flex-nowrap w-100 mt-3"
        v-if="showAddPaymentPlan"
      >
        <p class="button-plus mb-0 pointer" @click="$emit('add')">
          <i class="fal fa-plus c-coral mr-2"></i>
          {{ $t('PRODUCTS.LABELS.ADD_PAYMENT_PLAN') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import ProductPaymentPlan from '@/web/views/admin/products/product-form/ProductPaymentPlan';

export default {
  name: 'ProductPaymentPlansList',
  components: { ProductPaymentPlan },
  props: {
    paymentPlans: {
      type: Array,
    },
    showAddPaymentPlan: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped></style>
